export const FIRST_PAGE = 0
export const DEFAULT_BOUNDARIES = 1
export const DEFAULT_SIBLINGS = 1
export const DOTS = 'dots'
